// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKAvatar from 'components/MKAvatar';
import MKTypography from 'components/MKTypography';

// Images
import directorFinal from 'assets/csdd_images/directorFinal_.png';
import secondDirector from 'assets/csdd_images/secondDirector_.jpg';
import dennis_img from 'assets/csdd_images/dennis_final_final_pic.jpg';

const executive_members = [
  {
    id: 'collins-agyemang-sarpong',
    name: 'Collins Agyemang Sarpong',
    image: directorFinal,
    titles: '(FGIPS, MCIPS, MBA, CIPP, MGIM, MCCL)',
    description: (
      <MKTypography variant='body2' fontWeight='light' color='text'>
        Collins Agyemang Sarpong is a Chartered Procurement and Supply Chain
        Management Professional with over 20 years of experience in the field.
        He has held prominent positions as Head of Procurement and Supply Chain
        Management across various local and international organizations,
        including the United Nations Development Programme (UNDP), American
        Embassy, United Nations High Commissioner for Refugees (UNHCR),
        Agricultural Development Bank, and Standard Chartered Bank, Ghana & West
        Africa. Additionally, Collins serves as an Adjunct Lecturer at the
        University of Professional Studies, Accra (UPSA) and the Ghana Institute
        of Management and Public Administration (GIMPA).
        <br />
        <br />
        As a seasoned procurement expert, Collins consults for numerous
        organizations and serves on Entity Tender Committees for various public
        and private entities, providing his expertise as a Procurement and
        Supply Management Technical Advisor. His extensive experience as a
        facilitator has seen him develop and present over 100 training workshops
        and conferences on Procurement and Supply Chain Management, organized by
        esteemed institutions such as the Chartered Institute of Procurement and
        Supply (CIPS), Crown Agents, Ghana Supply Company, and several
        universities and organizations.
        <br />
        <br />
        Collins is a Chartered Member of the Chartered Institute of Procurement
        and Supply (MCIPS) from CIPS-UK, a Certified International Procurement
        Professional, and holds an MBA in Finance and Economics from the
        University of Leicester, UK. He is currently pursuing a Master of Arts
        in Corporate and Commercial Law from the University of Ghana Law School.
        <br />
        <br />
        Presently, Collins serves as a Consulting Procurement Specialist on the
        World Bank-funded Ghana Jobs and Skills Project. He is also the Managing
        Partner at Aedas Domos, CEO and Managing Consultant of ProSupp Consult,
        and a Board Member of the National Consortium of Voluntary
        Organizations, Ghana (NCVOG). Additionally, he is the immediate Past
        President of the Ghana Institute of Procurement and Supply.
      </MKTypography>
    ),
  },
  {
    id: 'simon-annan',
    name: 'Simon Annan',
    image: secondDirector,
    titles: '(FCIPS, FGIPS, FIPMP, CMILT, MBA)',
    description: (
      <MKTypography variant='body2' fontWeight='light' color='text'>
        Simon Annan is a doctoral student at Cranfield University, UK, and a
        Fellow of the Chartered Institute of Procurement and Supply (CIPS), UK,
        Ghana Institute of Procurement and Supply and Institute of Project
        Management Professionals and a Chartered member of the Institute of
        Logistics and Transport (CMILT), UK. He also holds an MBA in Strategic
        and Project Management.
        <br />
        <br />
        He is a Procurement and Supply Chain Management expert with over
        twenty-three years of experience in the banking, telecommunication,
        construction, manufacturing, and services sectors. He has held several
        senior management positions as Head of Procurement and Supply Chain with
        organizations such as Standard Chartered Bank Ghana, Ecobank Group, and
        Heritage Bank Ghana Limited. He has been a procurement consultant for
        many donor-funded projects in Ghana and across the continent. Notably,
        the Ghana National Household Registry, Public Financial Management
        Reform Project (PFMRP), Ghana Digital Acceleration Project (GDAP), etc.,
        have a total cumulative project spend of approximately USD310m.
        <br />
        <br />
        He is currently consulting for the Ministry of Communication and
        Digitalization as the Procurement and Contract Management Specialist on
        the Ghana Digital Acceleration Project (GDAP), also a World Bank-funded
        Project.
        <br />
        <br />
        Simon also serves on Entity Tender Committees for several public and
        private organizations as a Technical and Independent Advisor. He is a
        member of the Faculty Advisory Board of the Business School, Koforidua
        Technical University, a director of membership at the Institute of
        Project Management Professionals (IPMP), a Board Member of KENT
        International School, and a Board Chair of Optimal Change Partnership
        (NGO). He has developed and presented over 130 procurement and supply
        chain management topics at training workshops, seminars, and conferences
        within and outside Ghana.
        <br />
        <br />
        Simon is currently the President of the Ghana Institute of Procurement
        and Supply (GIPS), Vice President of the African Institute of Supply
        Chain Research (AISCR), West African Region and the CEO of SourceOne
        Management Services, Ghana.
      </MKTypography>
    ),
  },
  {
    id: 'dennis-teye-adjei',
    name: 'Dennis Teye-Adjei',
    image: dennis_img,
    titles: '',
    description: (
      <MKTypography variant='body2' fontWeight='light' color='text'>
        With over a decade in the Administration and Finance sector, Dennis
        Teye-Adjei brings a wealth of experience to our team. He has a
        certificate in Financial Analysis, a First degree in Business
        Administration, and MBA in Accounting and Finance. Dennis has a genuine
        drive for leadership and excellence and is dedicated to optimizing our
        operations and driving sustainable growth.
      </MKTypography>
    ),
  },
];

function Profile({ executiveMember }) {
  const member = executive_members.find((member) => {
    return executiveMember === member.id;
  });

  return (
    <MKBox component='section' py={{ xs: 6, sm: 12 }}>
      <Container>
        <Grid container item xs={12} justifyContent='center' mx='auto'>
          <MKBox mt={{ xs: -16, md: -20 }} textAlign='center'>
            <MKAvatar
              src={member.image}
              alt={member.name}
              sx={{ width: 200, height: 200 }}
              shadow='xl'
            />
          </MKBox>
          <Grid container justifyContent='center' py={6}>
            <Grid item xs={12} md={7} mx={{ xs: 'auto', sm: 6, md: 1 }}>
              <MKBox
                display='flex'
                justifyContent='center'
                alignItems='center'
                mb={1}
              >
                <MKTypography
                  textGradient
                  color='black'
                  textAlign='center'
                  variant='h3'
                >
                  {member.name}
                </MKTypography>
              </MKBox>
              <MKTypography
                textAlign='center'
                variant='body2'
                fontWeight='regular'
                color='black'
                opacity={0.85}
                mb={2}
              >
                {member.titles}
              </MKTypography>
              {member.description}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Profile;
